import { SvgIcon } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

import { IconTypes } from 'src/types';

export type SuccessProps = SvgIconProps;

export const Success: FC<SuccessProps> = props => (
  <SvgIcon aria-label={IconTypes.SUCCESS} {...props}>
    <g id="gk93D8BWZvo94r1R7-J4e">
      <path
        clipRule="evenodd"
        d="M22.0607 4.93934C22.6464 5.52513 22.6464 6.47487 22.0607 7.06066L10.0607 19.0607C9.47487 19.6464 8.52513 19.6464 7.93934 19.0607L1.93934 13.0607C1.35355 12.4749 1.35355 11.5251 1.93934 10.9393C2.52513 10.3536 3.47487 10.3536 4.06066 10.9393L9 15.8787L19.9393 4.93934C20.5251 4.35355 21.4749 4.35355 22.0607 4.93934Z"
        fillRule="evenodd"
      />
    </g>
  </SvgIcon>
);
